import { Skeleton } from '@/shared/components/ui/skeleton'
import { Typography, TypographyProps } from '@/shared/components/ui/typography'
import { useUserContext } from '@/shared/contexts/userContext'
import { cn } from '@/shared/lib/utils'
import { getTimeGreeting } from '@/shared/utils/timeGreeting'
import React, { ComponentProps } from 'react'

export const TimeBasedUserGreeting: React.FC<
  ComponentProps<'div'> | TypographyProps<'h3'>
> = (props) => {
  const { user, isLoading, error } = useUserContext()
  const greeting = getTimeGreeting()

  if (isLoading || error) {
    return (
      <div className="flex items-center gap-2">
        <Skeleton className="h-12 w-56" />
      </div>
    )
  }

  return (
    <Typography variant="h3" className={cn('text-primary', props.className)}>
      {greeting}
      {user?.firstName && `, ${user.firstName}`}
    </Typography>
  )
}
